import { useQuery } from '@tanstack/react-query';
import { getData } from 'util/Api';
import API from 'constants/api';

export interface VehicleType {
  id: number;
  name: string;
}

export interface GlobalsData {
  packages: {
    type: unknown[];
    size: unknown[];
    status: unknown[];
    deliveryEndorsementType: unknown[];
  };
  countries: unknown[];
  cities: unknown[];
  roles: unknown[];
  deliveryTerm: unknown[];
  userType: unknown[];
  dispatchTypes: unknown[];
  vehicleTypes: VehicleType[];
  notifierType: unknown[];
  daysService: unknown[];
  currentServices: unknown[];
}

async function fetchGlobals(countryID: number): Promise<GlobalsData> {
  const [
    packageType,
    packageSize,
    packageStatus,
    deliveryPackageType,
    countries,
    cities,
    roles,
    deliveryTerm,
    userType,
    dispatchTypes,
    notifierType,
    daysService,
    currentServices,
  ] = await Promise.all([
    getData(API.globals.packageType),
    getData(API.globals.packageSize),
    getData(API.globals.packageStatus),
    getData(API.globals.deliveryPackageType),
    getData(API.globals.countries),
    getData(`${API.globals.cities}/${countryID}`),
    getData(API.globals.roles),
    getData(API.globals.deliveryTerm),
    getData(API.globals.userType),
    getData(API.globals.dispatchTypes),
    getData(API.globals.notifierType),
    getData(API.globals.daysOfWeek),
    getData(API.globals.currentServices),
  ]);

  return {
    packages: {
      type: packageType ?? [],
      size: packageSize ?? [],
      status: packageStatus ?? [],
      deliveryEndorsementType: deliveryPackageType ?? [],
    },
    countries: countries ?? [],
    cities: cities ?? [],
    roles: roles ?? [],
    deliveryTerm: deliveryTerm ?? [],
    userType: userType ?? [],
    dispatchTypes: dispatchTypes ?? [],
    notifierType: notifierType ?? [],
    daysService: daysService ?? [],
    currentServices: currentServices ?? [],
    vehicleTypes: [
      { id: 1, name: 'Moto' },
      { id: 2, name: 'Auto' },
      { id: 3, name: 'Utilitario' },
      { id: 5, name: 'Utilitario Grande' },
    ],
  };
}

export function useGlobalsQuery(countryID: number | undefined) {
  return useQuery<GlobalsData>({
    queryKey: ['globals', countryID],
    queryFn: () => fetchGlobals(countryID!),
    staleTime: Infinity,
    gcTime: Infinity,
    enabled: !!countryID,
  });
}
